import React, { useEffect, useState } from 'react';

import EventCartDesktop from './sections/EventCartDesktop';
import { TicketsContextProvider } from '@/contexts/tickets/TicketsContext';
import {
  useTicketsSelected,
  usePayment,
  useBooking,
  useCheckout,
} from '@/store';
import useTicketsSelectionSummaryUpdate from '@/store/summary/useTicketSelectSummaryUpdate';
import EventCartMobile from './sections/EventCartMobile';
import useMobile from '@/hooks/useMobile';
import useBoletiaConfig from '@/hooks/useBoletiaConfig';
import useEventContext from '@/contexts/event/useEventContext';
import useAnalyticsEvents from '@/hooks/useAnalyticsEvents';

import FanPassDesktop from './sections/FanPassDesktop';
import FanPassMobile from './sections/FanPassMobile';
import { isEqualString } from '@/utils/validations';
import { eventHasMerch } from '@/config/onDemandMerchConfig';
import useLeavePage from '@/hooks/useLeavePage';
import useUserTracking from '@/hooks/userTracking';

export default function Home({ isMobile: isSsrMobile }) {
  const {
    event: {
      event: { id },
    },
  } = useEventContext();
  const [fanPass, setFanPass] = useState();

  const [isMobile, setIsMobile] = useState(isSsrMobile);
  const { isMobile: isCsrMobile } = useMobile();
  const {
    resetBooking,
    setStartDate,
    booking: { order },
  } = useBooking();
  const { releaseBooking } = useCheckout();
  const { resetBookingPayment } = usePayment();
  const { removeAllTickets } = useTicketsSelected();
  const { requiredFanPass } = useBoletiaConfig();

  const { selectionAbandoned } = useUserTracking();

  useTicketsSelectionSummaryUpdate();

  const { eventDetailView } = useAnalyticsEvents();

  const onChangeFanPass = (pass) => {
    if (isEqualString(pass, fanPass)) {
      setFanPass(null);
    }
  };

  useLeavePage(() => {
    selectionAbandoned();
  });

  useEffect(() => {
    if (order) {
      releaseBooking(order);
    }
    resetBooking();
    setStartDate();
    removeAllTickets();
    resetBookingPayment();
    setFanPass(requiredFanPass(id));

    if (eventHasMerch(id)) {
      eventDetailView(id);
    }
  }, []);

  useEffect(() => {
    setIsMobile(isCsrMobile);
  }, [isCsrMobile]);

  return (
    <TicketsContextProvider>
      {isMobile ? (
        <>
          {fanPass ? (
            <FanPassMobile onChange={onChangeFanPass} fanPass={fanPass} />
          ) : (
            <EventCartMobile />
          )}
        </>
      ) : (
        <>
          {fanPass ? (
            <FanPassDesktop onChange={onChangeFanPass} fanPass={fanPass} />
          ) : (
            <EventCartDesktop />
          )}
        </>
      )}
    </TicketsContextProvider>
  );
}
